import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {Link} from 'react-router';
import styled from 'styled-components';

import {
  BootstrapMaxSmallMediaQuery,
  BootstrapMinMediumMediaQuery,
} from 'app/general/mediaqueries';

type ArrowStepType = {
  name: string;
  url: string;
};

type Props = {
  steps: Array<ArrowStepType>;
  currentStep: number;
};

const ArrowSteps = styled.div`
  margin: auto;
  padding: 0;
  border-radius: 0.25em;

  &:after {
    clear: both;
    content: '';
    display: table;
  }

  .step {
    display: inline-block;
    float: left;
    position: relative;
    padding: 0;
    margin: 4px 4px 4px 0;

    &.current {
      a {
        color: #fff;
      }
    }

    &:after {
      display: inline-block;
      content: '\\00bb';
      color: #959fa5;
      margin: 0 1em;
    }

    &:first-of-type > span {
      padding-left: 1em;
      border-radius: 0.25em 0 0 0.25em;
    }

    &:last-of-type {
      margin-right: 0;

      &:after,
      > span:after {
        /* hide the triangle after the last step */
        display: none;
      }

      &:after {
        /* hide separator after the last item */
        display: none;
      }

      > span {
        padding-right: 1em;
        border-radius: 0 0.25em 0.25em 0;
      }
    }

    > span {
      display: inline-block;
      color: ${colors.darkGray};
      position: relative;
      padding: 0.75em 0em 0.75em 1.75em;
      background-color: ${colors.lightBg};
      border-color: ${colors.lightBg};
      font-size: 1rem;
    }

    &.current > span {
      color: ${colors.paleBlue};
      background-color: ${colors.selectedBg};
      border-color: ${colors.selectedBg};
    }

    &:after,
    > span:after {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      height: 0;
      width: 0;
      border: 24px solid transparent;
      border-right-width: 0;
      border-left-width: 20px;
    }

    > span:after {
      /* this is the colored triangle after each element */
      z-index: 2;
      border-left-color: inherit;
    }

    &:after {
      z-index: 1;
      -webkit-transform: translateX(4px);
      -moz-transform: translateX(4px);
      -ms-transform: translateX(4px);
      -o-transform: translateX(4px);
      transform: translateX(4px);
      border-left-color: #ffffff;
      /* reset style */
      margin: 0;
    }
  }
`;

export const ArrowProgressBar = ({steps, currentStep}: Props) => {
  return (
    <ArrowSteps className="d-flex justify-content-center">
      {steps.map((step, index) => {
        return (
          <div
            key={`arrow-${index}`}
            className={`step ${
              index === currentStep
                ? 'current'
                : index < currentStep
                ? 'done'
                : ''
            }`}
          >
            <span>
              <Link to={step.url}>
                <BootstrapMaxSmallMediaQuery>
                  {index + 1}.
                </BootstrapMaxSmallMediaQuery>
                <BootstrapMinMediumMediaQuery>
                  {index + 1}. {step.name}
                </BootstrapMinMediumMediaQuery>
              </Link>
            </span>
          </div>
        );
      })}
    </ArrowSteps>
  );
};
